import { jsx as n } from "react/jsx-runtime";
import { SectionTitleBody as o, SectionTitleHeading as a, SectionTitle as s } from "../SectionTitle/SectionTitle.js";
import { c as d } from "../clsx-OuTLNxxd.js";
const g = "OpeningText-module_opening-text__P-cfB",
  c = "OpeningText-module_heading__2raAl",
  r = "OpeningText-module_sub-heading__VN2cW",
  p = "OpeningText-module_body__6gqkd",
  t = {
    openingText: g,
    heading: c,
    subHeading: r,
    body: p
  },
  T = _ref => {
    let {
      children: e
    } = _ref;
    return /* @__PURE__ */n(o, {
      className: t.body,
      children: e
    });
  },
  u = _ref2 => {
    let {
      children: e
    } = _ref2;
    return /* @__PURE__ */n(a, {
      className: t.heading,
      priority: 1,
      children: e
    });
  },
  _ = _ref3 => {
    let {
      children: e
    } = _ref3;
    return /* @__PURE__ */n("h3", {
      className: t.subHeading,
      children: e
    });
  },
  b = _ref4 => {
    let {
      children: e,
      className: i = void 0
    } = _ref4;
    return /* @__PURE__ */n(s, {
      variant: "wide",
      className: d(t.openingText, i),
      "data-content-name": "opening_text",
      children: e
    });
  };
export { b as OpeningText, T as OpeningTextBody, u as OpeningTextHeading, _ as OpeningTextSubHeading };